import { TabTitle } from "../utils/helperFunctions";
//Landing page component
function Home() {
  let height = window.innerHeight;

  TabTitle("Home");
  return (
    <div style={{ height: { height } }} className="ui grid " id="landingPage">
      {/* <div className="ui column" style={{ backgroundColor: "black" }}>
        <img
          className="ui image big centered rounded"
          style={{ marginTop: "6rem" }}
          alt={"Me"}
          src={picture}
        ></img>
      </div> */}
      <div
        className="ui column"
        style={{ alignSelf: "center", textAlign: "center" }}
      >
        <img
          className="ui image big centered rounded"
          alt={"Business logo"}
          src={"/img/logo.webp"}
          style={{ width: "450px", objectFit: "none" }}
        ></img>
        <a href="about">
          <button
            id="submitText"
            className="ui button huge inverted basic learnMore teal circular"
          >
            Enhance Your Business Today
          </button>
        </a>
      </div>
    </div>
  );
}
export default Home;
